import ServerConfig from "../config/ServerConfig";
function formDataToObject(data) {
  let result = {};
  try {
    for (let key of data.keys()) {
      result[key] = data.get(key);
    }
    return result;
  } catch (e) {
    return data;
  }
}
const ServerCalls = {
  SendRequest: function(Method, Address, Token, Params, CallBack) {
    let xhttp = new XMLHttpRequest();
    let str = "";
    if (Method.toLowerCase() === "get" && Params)
      str =
        "?" +
        Object.keys(Params)
          .map(function(prop) {
            return [prop, Params[prop]].map(encodeURIComponent).join("=");
          })
          .join("&");
    xhttp.open(Method, Address + str, true);
    xhttp.setRequestHeader("Accept", "application/json");
    xhttp.onreadystatechange = function() {
      if (xhttp.readyState === 4) {
        if (xhttp.status === 200) {
          let Respond = xhttp.responseText;
          let ReqRes = JSON.parse(Respond);
          CallBack(ReqRes);
        } else {
          let Respond = xhttp.responseText;
          let ReqRes = {};
          try {
            ReqRes = JSON.parse(Respond);
          } catch (e) {
            ReqRes = {};
            ReqRes.status = xhttp.status;
          }
          CallBack(ReqRes);
        }
      }
    };
    xhttp.onerror = function() {
      let Respond = xhttp.responseText;
      CallBack({ status: xhttp.status, message: Respond });
    };
    if (Token && Token !== null) xhttp.setRequestHeader("Authorization", Token);
    if (Params instanceof FormData) {
      xhttp.send(Params);
    } else {
      xhttp.setRequestHeader("Content-Type", "application/json");
      xhttp.send(JSON.stringify(Params));
    }
  },
  getLandingData(name, cb) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.LandingServer + "/get",
      null,
      { tag: name },
      cb
    );
  },
  getCareerJobs(cb) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.CareerServer + "/all",
      null,
      null,
      cb
    );
  },
  getCareerJob(jobTag, cb) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.CareerServer + "/get",
      null,
      { jobTag },
      cb
    );
  },
  applyJob(data, cb) {
    let xhttp = new XMLHttpRequest();
    xhttp.open("POST", ServerConfig.CareerServer + "/sign_up", true);
    xhttp.onreadystatechange = function() {
      if (xhttp.readyState === 4 && xhttp.status === 200) {
        cb(JSON.parse(xhttp.responseText));
      }
    };
    xhttp.send(data);
  },
  sendContact(data, cb) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.ContactServer + "/send",
      null,
      data,
      cb
    );
  },
  sendSms(data, cb) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.SmsServer + "/link",
      null,
      data,
      cb
    );
  },
  getGroupedCategory(CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.FaqServer + "/all",
      false,
      null,
      CallBack
    );
  },
  getTypeFaqs(type, CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.FaqServer + "/type",
      false,
      { type },
      CallBack
    );
  },
  searchTypeFaqs(type, words, CallBack) {},
  searchFaqs(type, words, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.FaqServer + `/search`,
      false,
      { words, type },
      CallBack
    );
  },
  getEducationPosts(CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.EducationServer + "/all_posts",
      null,
      null,
      CallBack
    );
  },
  getEducationCategoryPosts(tag, CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.EducationServer + "/category_posts",
      null,
      { tag },
      CallBack
    );
  },
  getEducationTypePosts(id, CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.EducationServer + "/type_posts",
      null,
      { id },
      CallBack
    );
  },
  getEducationPost(data, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.EducationServer + "/get_post",
      null,
      data,
      CallBack
    );
  },
  signUpEducation(data, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.EducationServer + "/sign_in",
      null,
      data,
      CallBack
    );
  },
  verifyEducation(data, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.EducationServer + "/verify",
      null,
      data,
      CallBack
    );
  },
  searchEducationPosts(words, CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.EducationServer + "/search_posts",
      null,
      { words },
      CallBack
    );
  },
  signInBanning(data, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.BanningServer + "/sign_in",
      null,
      data,
      CallBack
    );
  },
  verifyBanning(data, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.BanningServer + "/verify",
      null,
      data,
      CallBack
    );
  },
  getBanningRecords(data, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.BanningServer + "/get_records",
      null,
      data,
      CallBack
    );
  },
  getPromotersConfig(CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.PromoterServer + "/public/config",
      null,
      null,
      CallBack
    );
  },
  loginPromoters(data, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.PromoterServer + "/promoters/sign-in",
      null,
      data,
      CallBack
    );
  },
  searchDriversPromoter(data, token, CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.PromoterServer + "/drivers/search",
      "bearer " + token,
      data,
      CallBack
    );
  },
  getPromoterDriverProfile(data, token, CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.PromoterServer + "/drivers/profile",
      "bearer " + token,
      data,
      CallBack
    );
  },
  signUpPromoterDriver(data, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.PromoterServer + "/drivers/sign-up",
      null,
      data,
      CallBack
    );
  },
  verifyPromoterDriver(data, token, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.PromoterServer + "/drivers/profile",
      "bearer " + token,
      data,
      CallBack
    );
  },
  verifyPromoterFinal(data, token, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.PromoterServer + "/documents/verify",
      "bearer " + token,
      data,
      CallBack
    );
  },
  uploadPromoterDoc(data, token, CallBack) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.PromoterServer + "/documents/upload",
      "bearer " + token,
      data,
      CallBack
    );
  },
  getCurrentDate(CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.GeneralServer + "/getcurrentdate",
      null,
      null,
      CallBack
    );
  },
  getCityData(CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.GeneralServerV2 + "/cities",
      null,
      null,
      CallBack
    );
  },
  submitDriver(data, cb) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.GeneralServerV2 + "/driver/sign_up",
      null,
      data,
      cb
    );
  },
  driverAppSmsLink(data, cb) {
    ServerCalls.SendRequest(
      "POST",
      ServerConfig.GeneralServer + "/sms/link",
      null,
      data,
      cb
    );
  },
  getApkDownloadUrl(CallBack) {
    ServerCalls.SendRequest(
      "GET",
      ServerConfig.GeneralServerV2 + "/app-url",
      null,
      null,
      CallBack
    );
  },
};

module.exports = ServerCalls;



// WEBPACK FOOTER //
// ./src/js/utils/ServerCalls.js